import { Route, Redirect } from "react-router-dom"
import React, { Component } from 'react';
import { connect } from 'react-redux';

class UserOptionalRoute extends Component {
    state = {}
    render() {
        return (
            <Route exact={this.props.exact} path={this.props.path}> {this.props.children} </Route>
        )
    }
}
function mapStateToProps(state) {
    return {
        user: state.user
    }
}
export default connect(mapStateToProps)(UserOptionalRoute);
